import script from "./settingsMenu.vue?vue&type=script&setup=true&lang=js"
export * from "./settingsMenu.vue?vue&type=script&setup=true&lang=js"

import "@vueform/toggle/themes/default.css?vue&type=style&index=0&lang=css&external"
import "./settingsMenu.vue?vue&type=style&index=1&id=5908f41c&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-5908f41c"]])

export default __exports__